import { Menu, X } from 'lucide-react';
import { useState, useEffect } from 'react';
import { eventInfo } from '../../data/landingData';
import { SpotsRemaining } from './Countdown';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#brotherhood', label: 'Brotherhood' },
    { href: '#benefits', label: 'Benefits' },
    { href: '#speakers', label: 'Guides' },
    { href: '#schedule', label: 'Journey' },
    { href: '#venue', label: 'Venue' },
    { href: '#pricing', label: 'Register' },
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'glass py-3' : 'bg-transparent py-5'
      }`}
      data-testid="header"
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a href="#" className="flex items-center gap-3" data-testid="logo">
          <div className="w-10 h-10 rounded-full overflow-hidden border border-[#D4AF37]/50 flex-shrink-0">
            <img
              src="https://customer-assets-4nw71qhi.emergentagent.net/job_analytics-live-1/artifacts/8w3x6659_brotherhood-reset-logo.jpg"
              alt="The Reset · The Brotherhood Circle"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="hidden sm:block">
            <p className="font-cormorant text-lg font-medium text-white leading-tight">The Reset</p>
            <p className="font-manrope text-xs text-zinc-500">{eventInfo.dates}</p>
          </div>
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`font-manrope text-sm transition-colors ${
                link.label === 'Register'
                  ? 'text-[#D4AF37] font-semibold hover:text-[#B8860B]'
                  : 'text-zinc-400 hover:text-white'
              }`}
              data-testid={`nav-${link.label.toLowerCase()}`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Desktop CTA + Spots */}
        <div className="hidden lg:flex items-center gap-4">
          <div className="scale-90">
            <SpotsRemaining spots={eventInfo.spotsRemaining} />
          </div>
          <a
            href="#pricing"
            className="bg-[#D4AF37] text-[#0A0A0A] px-6 py-2.5 rounded-full font-manrope font-semibold text-sm hover:bg-[#B8860B] transition-all hover:-translate-y-0.5"
            data-testid="header-cta"
          >
            Register Now
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="lg:hidden text-white p-2"
          data-testid="mobile-menu-toggle"
        >
          {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden glass border-t border-white/10 mt-3">
          <nav className="flex flex-col p-6 space-y-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`font-manrope text-lg ${
                  link.label === 'Register'
                    ? 'text-[#D4AF37] font-semibold'
                    : 'text-zinc-300'
                }`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="#pricing"
              onClick={() => setIsMobileMenuOpen(false)}
              className="bg-[#D4AF37] text-[#0A0A0A] px-6 py-3 rounded-full font-manrope font-semibold text-center mt-4"
            >
              Register Now — ${eventInfo.price.toLocaleString()}
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};
